import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=fb08ec6a&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=fb08ec6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb08ec6a",
  null
  
)

export default component.exports